import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { VhToastContainerComponent } from '@vendorhub/shared/ui';
import { NavbarComponent } from '../navbar/navbar.component';
import { FooterComponent } from '../footer/footer.component';

/**
 * Default page shell for authenticated pages and public marketplace
 * surfaces: sticky navbar, `<router-outlet>`, footer, and the toast stack.
 */
@Component({
  selector: 'vh-main-layout',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, FooterComponent, VhToastContainerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <vh-navbar />
    <main class="vh-main">
      <router-outlet />
    </main>
    <vh-footer />
    <vh-toast-container />
  `,
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {}
